module.exports = __webpack_public_path__ + "static/media/assessment_course-outline.f2ad421f.png";